export default __webpack_public_path__ + "static/media/SWAMP-BUSD.00f89547.svg";